import { Component, OnInit, Input } from '@angular/core';

import {OrdemServicoNavigationService} from "../../shared/ordem-servico-navigation.service";
import {OrdemServico} from "../../shared/ordem-servico.model";
import {UtilService} from "../../../../shared/services/util.service";
import {OrdemServicoService} from "../../shared/ordem-servico.service";
import {ServicoApiService} from "../../../servicos/shared/servico-api.service";
import {MaterialOrdemServicoApiService} from "../../../../almoxarifado/materiais/materiais-ordem-servico/shared/material-ordem-servico-api.service";

@Component({
    selector: 'app-ordem-servico-item-table',
    template: require('./ordem-servico-item-table.component.html'),
    styles: [require('./ordem-servico-item-table.component.css')]
})
export class OrdemServicoItemTableComponent implements OnInit {
    @Input() osObject: OrdemServico = new OrdemServico();
    @Input() statusObject: any = {};
    @Input() total: number = 0;
    @Input() totalOs: number = 0;
    @Input() list: any[] = [];
    @Input() tipo: string = '';

    constructor(
        private _ordemServicoNavigationService: OrdemServicoNavigationService,
        private _ordemServicoService: OrdemServicoService,
        private _servicoApiService: ServicoApiService,
        private _materialOrdemServicoApiService: MaterialOrdemServicoApiService,
        private _utilService: UtilService
    ) { }

    ngOnInit() {
    }

    clickAddItem() {
        let tipoServico = this._ordemServicoService.getItemTipoServico();
        let tipoMaterial = this._ordemServicoService.getItemTipoMaterial();
        if (this.tipo === 'servico') {
            this._ordemServicoNavigationService.goToNewServico(this.osObject.id, tipoServico.Key);
        } else {
            this._ordemServicoNavigationService.goToNewMaterial(this.osObject.id, tipoMaterial.Key);
        }
    }

    clickEditMateriaisServicos(item: any) {
        if (this.tipo === 'servico') {
            this._ordemServicoNavigationService.goToEditServico(this.osObject.id, item.Tipo.Key, item.id);
        } else {
            this._ordemServicoNavigationService.goToEditMaterial(this.osObject.id, item.Tipo.Key, item.id);
        }
    }

    clickDeleteMateriaisServicos(item: any) {
        var onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list.splice(x, 1);
                        this.total -= item.valor;
                        this.totalOs -= item.valor;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        var serviceType: any = this._ordemServicoService.getItemTipoServico();
        if (item.Tipo.Key === serviceType.Key) {
            this._servicoApiService.onDeleteServicoOrdemServico(item.id, onDone);
        } else {
            this._materialOrdemServicoApiService.onDeleteMaterialOrdemServico(item.id, onDone);
        }
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/ordens-servico/ordem-servico-item/ordem-servico-item-table/ordem-servico-item-table.component.ts
 **/